import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import LanguageDetector from 'i18next-browser-languagedetector'
import { translations } from './i18n-loader'

const SUPPORTED_LANGUAGES = ['pt', 'en', 'es']
const DEFAULT_LANGUAGE = 'pt'
const STORAGE_KEY = 'i18nextLng'

i18next
  .use(LanguageDetector)
  .init({
    resources: {
      pt: { translation: translations.pt },
      en: { translation: translations.en },
      es: { translation: translations.es }
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false // Vue já faz escape
    },
    detection: {
      // SYN-665: 'querystring' first so an e-mail deep link (?lang=xx) sets + persists the locale
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
      lookupLocalStorage: STORAGE_KEY
    }
  })

export default i18next
export { I18NextVue, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, STORAGE_KEY }
